'use client';

// This component ensures Sentry is initialized on the client side
import { useEffect } from 'react';

export default function SentryClientInit() {
  useEffect(() => {
    // Dynamic import to ensure it only runs on client
    import('../../sentry.client.config').then(() => {
      console.log('[Sentry] Client-side configuration loaded');
    }).catch((error) => {
      console.error('[Sentry] Failed to load client configuration:', error);
    });
  }, []);
  
  return null;
}
